module.exports = __webpack_public_path__ + "img/logo_black.ceef5502.png";